import { Table } from "./Table";
import { Form } from "./Form";
import { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
export interface IModel {
  open: boolean;
}

const MassMailSetting = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ open: false } as IModel);
  const [reload, setReload] = useState(false);

  const toast = useRef<any>(null);

  const hideDialog = () => {
    setModal({ open: false });
  };
  return (
    <>
      <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} />
      <Form open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default MassMailSetting;
